import { SearchForm } from './SearchForm'
import { withSearchForm } from './withSearchForm'

const ConnectedSearchForm = withSearchForm(SearchForm)

export { ConnectedSearchForm as SearchForm }
